import React, { FC } from 'react'

import {
  ProjectBasicInfoDetail,
  ProjectLocationDetail,
  ProjectBuildingDetail,
} from 'src/components/molecules'
import { ProjectDetailCompassInformation } from 'src/components/organisms/projects/ProjectDetailCompassInformation'

import { ProfileEntity, ProjectDetailEntity } from 'src/types'

type Props = {
  project: ProjectDetailEntity
  profile: ProfileEntity
  className?: string
}

export const ProjectDetail: FC<Props> = ({ project, profile, className }) => {
  return (
    <div className={className}>
      <div className="tw-flex tw-gap-s4">
        <div className="tw-w-[20rem] tw-shrink-0 tw-grid tw-gap-s3 tw-h-fit">
          <ProjectBasicInfoDetail profile={profile} project={project} />
          <hr className="tw-border-border-primary" />
          <ProjectLocationDetail project={project} />
          <hr className="tw-border-border-primary" />
          <ProjectBuildingDetail project={project} />
        </div>

        <ProjectDetailCompassInformation
          project={project}
          profile={profile}
          className="tw-w-full tw-h-fit tw-shrink"
        />
      </div>
    </div>
  )
}
